export enum BOOKING_PAGES {
  SLOT_PICKER = 1,
  CONTACT_DETAILS = 2,
  PASSENGER_INFO = 3,
  BOOKING_SUMMARY = 4,
}

export const BESTCAMP_HOST_SLUG = 'bookings';
